export default (store, userActions, elementsActions, clearUserAddress = true) => {
    if (clearUserAddress) {
        store.dispatch(userActions.setUserOrderMethod(''));
        store.dispatch(userActions.setUserAddress(''));
        store.dispatch(userActions.setSelectedStore(''));
    }
    store.dispatch(userActions.setUserCart([]));
    store.dispatch(userActions.setUserCartId(null));
    store.dispatch(elementsActions.setModalObject(null));
};
